import { jsx } from "react/jsx-runtime";
import { FormViewerStatic } from "../../components/root/form-viewer-static.js";
import { useFormActions } from "../../hooks/use-form-actions.js";
import { getForm } from "../controller-props.js";
import FormLoadingError from "./form-loading-error/form-loading-error.js";
import Providers from "./providers.js";
import { useSimulateError } from "./use-simulate-error.js";
const Widget = ({
  forwardedRef,
  controller,
  i18n,
  formId,
  values,
  stepId,
  onChange,
  onBlur,
  onFocus,
  onStepIdChange,
  errors,
  onValidate,
  onError,
  externalData,
  overrides,
  bi,
  biFormFillSessionId,
  forcedState,
  httpClient,
  fields,
  WixRicosViewer,
  panorama,
  onSubmit,
  onSubmitSuccess,
  onSubmitFailure,
  onStatusChange
}) => {
  const { wfActions, wfConfig, wfResults } = controller;
  if (!wfActions || !wfConfig || !wfResults) {
    throw new Error("Missing controller props");
  }
  useSimulateError(wfConfig);
  const form = getForm(wfConfig, formId);
  const { formActions, inProgress } = useFormActions({
    wfActions,
    wfResults
  });
  return /* @__PURE__ */ jsx(Providers, { config: wfConfig, children: form ? /* @__PURE__ */ jsx(
    FormViewerStatic,
    {
      httpClient,
      ref: forwardedRef,
      actions: formActions,
      config: wfConfig,
      form,
      enableAutofill: !wfConfig.isEditor && !wfConfig.isComposer,
      values,
      stepId,
      onChange,
      onBlur,
      onFocus,
      onStepIdChange,
      errors,
      onValidate,
      onSubmit,
      onSubmitSuccess,
      onSubmitFailure,
      onStatusChange,
      isMobile: wfConfig.isMobile,
      isRTL: wfConfig.isRTL,
      i18n,
      bi,
      biFormFillSessionId,
      externalData,
      translations: wfConfig.translations,
      localeDataset: wfConfig.localeDataset,
      overrides,
      forcedState,
      inProgress,
      experiments: wfConfig.experiments,
      currency: wfConfig.currency,
      fields,
      WixRicosViewer,
      fieldInitialData: wfConfig.fieldInitialData,
      panorama
    }
  ) : /* @__PURE__ */ jsx(
    FormLoadingError,
    {
      formId,
      i18n,
      translations: wfConfig.translations,
      language: wfConfig.language,
      onError,
      isRTL: wfConfig.isRTL
    }
  ) });
};
export {
  Widget as default
};
//# sourceMappingURL=widget.js.map
